export const getBlobObjectURL = (
  url: string,
  getAuthHeader: () => { Authorization: string } | undefined,
): Promise<string> => {
  const authHeader = getAuthHeader()

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...authHeader,
    },
    credentials: 'include',
    body: undefined,
  })
    .then((response) => {
      return response.blob()
    })
    .then((blob) => {
      return URL.createObjectURL(blob)
    })
    .catch((error) => {
      console.log(error)
      return ''
    })
}
